export default "__VITE_ASSET__BpRpA3OJ__"